"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BARCODE = exports.QRCodeType = void 0;
var QRCodeType;
(function (QRCodeType) {
    QRCodeType[QRCodeType["BENEFITS"] = 0] = "BENEFITS";
    QRCodeType[QRCodeType["EVENT"] = 1] = "EVENT";
    QRCodeType[QRCodeType["INNMELDING"] = 2] = "INNMELDING";
    QRCodeType[QRCodeType["TUTTILOGIN"] = 3] = "TUTTILOGIN";
})(QRCodeType = exports.QRCodeType || (exports.QRCodeType = {}));
var BARCODE;
(function (BARCODE) {
    BARCODE["DATAMATRIX"] = "datamatrix";
    BARCODE["QRCODE"] = "qrcode";
    BARCODE["CODE128"] = "code128";
})(BARCODE = exports.BARCODE || (exports.BARCODE = {}));
//# sourceMappingURL=qr.js.map